import { useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { PaginatedRequestParams } from "api";
import dayjs from "dayjs";
import { ReportApiService } from "features/report/api/report-api.services";
import { ReportViewItem } from "features/report/dashboard/report-viewItem"
import { SideBarFilterView } from "features/report/dashboard/sidebarFilter";
import { useEffect, useRef, useState } from "react";

export const PurchaseItemView = () => {
    const [reportType, setReportType] = useState(5); // default TAT
    const today = dayjs();
    const [entryTypeData, setEntryTypeId] = useState('')
    const [reportDataSelect, setReportTypeData] = useState('')
    const [GranularityId, setGranularity] = useState(1)
    const startOfPrevMonth = today.startOf("month");
    const endOfPrevMonth = today;

    const [state, setState] = useState({
        reportType: [],
        granularity: [],
        entryType: []
    } as any);
    const didFetch = useRef(false);
    const [materialId, setMaterialId] = useState<number | null>(null);
    const [isExcludeInSideVehicle, setIsExcludeInSideVehicle] = useState<boolean>(false);
    const inital = async () => {
        try {
            const [reportTypeRes, granularityRes, entryTypeRes] = await Promise.all([
                ReportApiService().getReportCommonList({ Flag: "ReportType", } as PaginatedRequestParams),
                ReportApiService().getReportCommonList({ Flag: "Granularity" } as PaginatedRequestParams),
                ReportApiService().getReportCommonList({ Flag: "ReportEntryType", Id: reportDataSelect } as PaginatedRequestParams),
            ]);
            setState({
                reportType: reportTypeRes,
                granularity: granularityRes,
                entryType: entryTypeRes,
            });
        } catch (error: any) {
            message.error(error);
        }
    };

    useEffect(() => {
        didFetch.current = true;
        setReportType(5);
        inital();
    }, [reportDataSelect]);

    const [filterTable, setFilterTable] = useState({
        ReportTypeId: 5,
        Page: 1,
        Size: 10
    } as any)
    const [filter, setFilter] = useState({
        StartDate: startOfPrevMonth.format("YYYY-MM-DD"),
        EndDate: endOfPrevMonth.format("YYYY-MM-DD"),
        GarnularityId: 1, // default Month
        ReportTypeId: 5,
        MaterialId: materialId,
        IsExcludeInSideVehicle: isExcludeInSideVehicle,
        Page:1,
        size:10
    } as any);
    const [dateRange, setDateRange] = useState<[dayjs.Dayjs, dayjs.Dayjs]>([
        startOfPrevMonth,
        endOfPrevMonth,
    ]);
    const { getReportViewList, getReportTableData } = ReportApiService();

    const { isLoading:purchaseGraphLoading,data, isFetching ,refetch:reportViewData} = useQuery(
        ["reportViewList", filter],
        () => getReportViewList(filter),
        { enabled: !!filter }
    );

    const { data: reporttable, isFetching: isreportFetching } = useQuery(
        ["commonReportTableList", filterTable],
        () => getReportTableData(filterTable),
        { enabled: !!filterTable }
    );
    
    return (
        <>
            <div style={{ display: "flex", height: "100%" }}>
                <div style={{ flex: 1 }}>
                    <ReportViewItem
                        data={data}
                         isLoading ={purchaseGraphLoading}
                        reportType={reportType}
                        isFetching={isFetching}
                        entryTypeId={entryTypeData}     
                        reporttable={reporttable?.res}
                        dateRange={dateRange}
                        GranularityId={GranularityId}
                        materialId={materialId}
                        filter={filter}
                        isreportFetching={isreportFetching}
                         weightType=""
                         onRefresh={reportViewData} 
                         setFilterTable={setFilterTable}
                    />
                </div>

                <div
                    style={{
                        width: "300px",
                        borderLeft: "1px solid #FFF0DD",
                        padding: "16px",
                        background: "#FFFFFF",
                        marginTop: -18,
                        marginRight: -18,
                    }}
                >
                    <SideBarFilterView
                        data={state}
                        filter={filter}
                        setFilter={setFilter}
                        setFilterTable={setFilterTable}
                        filterTable={filterTable}
                        ReportType={5}
                        setReportTypeData={setReportTypeData}
                        reportDataSelect={reportDataSelect}
                        setEntryTypeId={setEntryTypeId}
                        dateRange={dateRange}
                        setDateRange={setDateRange}
                        setGranularity={setGranularity}
                        GarnularityId={GranularityId}
                        setMaterialId={setMaterialId}
                        materialId={materialId}
                        setIsExcludeInSideVehicle={setIsExcludeInSideVehicle}
                        isExcludeInSideVehicle={isExcludeInSideVehicle}
                        reporttable={reporttable?.res}
                    />
                </div>
            </div>
        </>
    )
}